<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="12">
          <b-form-group
            description="Choose from different themes for the card images."
          >
            <drop-down-field
                field-name="Theme Selection:"
                field-key="theme"
                :options-json="optionsJSON"
                :selected-value="settingsUser.theme"
                select-word="Theme"
                @selected-option="handleOptionsSelect"
            />
          </b-form-group>
          <b-form-group
            description="Select the size of the card grid, including options like 4x4, 6x6, or other grid dimensions. Larger grids can be more challenging."
          >
            <label>Card Grid Size:</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.gridSize"
              :min="gridSizeMin"
              :max="gridSizeMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group>
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import DropDownField from "@/components/blockResources/_components/dropDownField";
import optionsJSON from "../../assets/json/optionsJSON.json";
export default {
  name: "Settings_MatchGame",
  components: {
    DropDownField
  },
  mixins: [ResourceBlockSettings],
  methods: {
    handleOptionsSelect({key, option}){
      debugger;
      switch (key){
        case 'theme':
          this.settingsUser.theme = option.value ? option.value : null;
          break;
        default:
          //applog bug
          break;
      }
      this.handleSettingsUserChange();
    }
  },
  data() {
    return {
      optionsJSON,
      settingsUser: {
        gridSize:
          this.settings && this.settings.user && this.settings.user.gridSize
            ? this.settings.user.gridSize
            : 2,
        theme:
          this.settings && this.settings.user && this.settings.user.theme
            ? this.settings.user.theme
            : "logos",
        _isSoundOn:
          this.settings &&
          this.settings.user &&
          this.settings.user._isSoundOn !== undefined
            ? this.settings.user._isSoundOn
            : true,
        _hasBGMusic:
          this.settings &&
          this.settings.user &&
          this.settings.user._hasBGMusic !== undefined
            ? this.settings.user._hasBGMusic
            : true,
        _isDisplayStats:
          this.settings &&
          this.settings.user &&
          this.settings.user._isDisplayStats !== undefined
            ? this.settings.user._isDisplayStats
            : true
      },
      toggles: [
        {
          name: "SoundEffects",
          description: "Sound effects during gameplay",
          property: "_isSoundOn",
          type: "btns",
          text: "Sound Effects",
          isAvail: true,
          value: true
        },
        {
          name: "BackgroundMusic",
          description: "Play Background Music during GamePlay",
          property: "_hasBGMusic",
          type: "btns",
          text: "Background Music",
          isAvail: true,
          value: false
        },
        {
          name: "Progress Stats",
          description: "Display their turns, times, scores",
          property: "_isDisplayStats",
          type: "btns",
          text: "Show Progress Stats",
          isAvail: true,
          value: true
        }
      ],
      //****** App Specific
      gridSizeMin: 2,
      gridSizeMax: 5
    };
  }
};
</script>

<style lang="scss" scoped></style>
